import React, { useEffect, useRef } from 'react';
import { FaTimes } from 'react-icons/fa';
import './InfoMessage.css';

const InfoMessage = ({ message, onClose }) => {
  const messageRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (messageRef.current && !messageRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  return (
    <div className="info-message-overlay">
      <div className="info-message" ref={messageRef}>
        <div className="info-message__header">
          <button className="info-message__close-button" onClick={onClose}>
            <FaTimes />
          </button>
        </div>
        <div className="info-message__content">
          <span>{message}</span>
        </div>
      </div>
    </div>
  );
};

export default InfoMessage;
